(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function ($) {
  if (jQuery != 'undefined' && $('.facebook-content').length) {
    if ($(window).width() >= 1200) {
      setTimeout(function () {
        $(".facebook-content").append('<div class="fb-page" data-href="' + URL_FACEBOOK + '" data-width="465" data-height="280" data-small-header="false" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true" data-show-posts="true"><div class="fb-xfbml-parse-ignore"><blockquote cite="' + URL_FACEBOOK + '"><a href="' + URL_FACEBOOK + '">Moreira Garcia</a></blockquote></div></div>');
        FB.XFBML.parse();
        $('.loading-facebook').fadeOut('slow');
      }, 13000);
    }
  }
}(jQuery);

},{}]},{},[1]);
